export default {
	isEmpty: (arg) => {
		if (Array.isArray(arg)) {
			return arg.length === 0;
		}
		if (typeof arg === 'object' && arg !== null) {
			return Object.keys(arg).length === 0;
		}
		if (typeof arg === 'string' || typeof arg === 'number') {
			return !arg;
		}
		return !arg;
	},
	setNewProperty(property, value) {
		return function p(obj) {
			const newObj = { ...obj };
			newObj[property] = typeof value === 'function' ? value(obj) : value;
			return newObj;
		};
	},
	map: (fn, col) => col.map(fn),
	getDeeper(...args) {
		return function inner(item) {
			let newItem = null;
			if (item && item.length) {
				[newItem] = item;
			} else {
				newItem = { ...item };
			}
			args.forEach((el) => {
				newItem = (newItem || {})[el];
			});
			return newItem;
		};
	},
};



// WEBPACK FOOTER //
// ./src/shared/lib.js